import { useEffect } from 'react';

/**
 * Hook to handle full screen mode with keyboard support (Escape key)
 */
export const useFullScreen = (isFullScreen: boolean, onClose: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isFullScreen) {
        onClose();
      }
    };

    if (isFullScreen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFullScreen, onClose]);
};

